import { DefaultService } from "../DefaultService";

export default class B2BClienteSegmentoService extends DefaultService {
    constructor(http, router, env) {
        super(http, router, env)
    }

    findAll(...params) {
        return this._http.get(encodeURI(`${this._env}/b2bsegmento/cliente/findall.json?param=${params}`), this._headers)
        .then(res => {
            return res.body;
        },
        err => {
            this.handleError(err);
        });
    }

    insertBulk(assClienteSegmento) {
        return this._http.post(`${this._env}/b2bsegmento/cliente/insert-bulk`, assClienteSegmento, this._headers).then(res => {
            return res.body;
        }, err => {
            this.handleError(err)
        });
    }
}